<template>
    <div class="order">
        <el-dialog :visible.sync="toggleCreateFolderVisible">
            <ValidationObserver v-slot="{ handleSubmit, valid }">
            <form @submit.prevent="handleSubmit(createFolderSubmit)">
                <div>
                <ValidationProvider rules="required">
                    <base-input class="mb-0" :label="'Name new Folder'" type="text" :placeholder="'Choose folder name'"
                    v-model="form.name">
                    </base-input>
                </ValidationProvider>
                <SubmitButton :text="$t('folder.create')" :isDisabled="!valid" />
                </div>
            </form>
            </ValidationObserver>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog } from 'element-ui';
import SubmitButton from 'src/components/Buttons/SubmitButton.vue';
import {BaseInput } from 'src/components/index';
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", required);

export default {
  components: {
    [Dialog.name]: Dialog,
    SubmitButton,
    BaseInput
  },
  data() {
    return {
      form: {
        name: '',
      },
      toggleCreateFolderVisible: true,
    };
  },
  methods: {
    async createFolderSubmit() {
      this.$preloader.fadeIn();
      await this.$store.dispatch('createFolder', this.form);
      this.$emit('folderCreated');
      this.toggleCreateFolderVisible = false;
      this.$preloader.fadeOut();
    },
  },
  watch: {
    toggleCreateFolderVisible: function(val) {
      if (!val) {
            this.$emit('hideForm');
        }
      }
  }

};

</script>